// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/.pnpm/css-loader@3.6.0_webpack@4.46.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app{font-family:Roboto,sans-serif}div.v-snack{margin-right:30px}div.v-snack .v-snack__content{font-size:1rem;justify-content:space-between}#update-button{margin-left:30px}", ""]);
// Exports
module.exports = exports;
